// Lives in the page header, not the toolbar: a toolbar slot sits beside the filters and shoves them.
export function RefreshingHint() {
    return (
        <span className="ml-2 inline-flex items-center gap-1.5 text-xs text-gray-500" role="status">
            <span className="h-3.5 w-3.5 rounded-full border-2 border-gray-400 border-t-transparent animate-spin" />
            Refreshing…
        </span>
    );
}
